<script setup>
// import i18n from "@/i18n"
import Table from "./components/table"
import { getProductDetail } from "@/service";
import { onMounted, ref, provide } from "vue"
import { useRoute } from "vue-router";
import searchCom from "./components/search"
import collapseImg from "@/assets/images/products/collapse.svg"
import { getLangValue, getLangValueByKey } from "@/utils/common"; //获取后端语言
import { showMessage } from "@/utils/hooks/message"
import { product_data_transport } from "@/service/apiList/products.js"
import {getB2cByUser} from "@/service/apiList/b2c.js"
const PageHeaderT = getLangValue('product-management', "title")

// const router = useRouter()
const route = useRoute()
const PageHeaderItems = ref([
    {
        text: getLangValue('product-management', "title"),
        active: false,
        // href: "#",
    },
])
// const templateName = ref("")
const tableRef = ref(null)
// const publicTypeList = ref([])
// const chart_hot = ref(null)
const selectedInfo = ref('') // 选中产品数据
provide('selectedInfo', selectedInfo) //选中产品数据
// const current_tab = ref(0)
const showSearch = ref(true)
const searchRef = ref(null)
const tabList = ref([
    { name: getLangValue('product-management', "all"), number: 0, id: '', },
    { name: getLangValue('product-management', "notpublic"), number: 0, id: 1, },
    { name: getLangValue('product-management', "Opasc"), number: 0, id: 3, },
    { name: getLangValue('product-management', "completelypublic"), number: 0, id: 2, },
])

//methods

// const handlerToggleTab = (i, id) => {
//     current_tab.value = i
//     // 搜索数据 控制参数
//     tableRef.value.searchInfo.publicType = id;

// }
// const handleSearch = () => {
//     tableRef.value.searchInfo.templateName = templateName.value;
//     // 显示弹框则高级搜索
//     // if (!showSearch.value) {
//     //     tableRef.value.searchInfo.hscode = ""
//     //     tableRef.value.searchInfo.price = ""
//     //     tableRef.value.searchInfo.inventory = ""
//     //     tableRef.value.searchInfo.hand = []
//     //     tableRef.value.searchInfo.skin = []
//     //     tableRef.value.searchInfo.heat = []
//     // }else{
//     //     console.log(searchRef.value)
//     //     tableRef.value.searchInfo.hscode = searchRef.value.searchInfo.hscode
//     //     tableRef.value.searchInfo.price = searchRef.value.searchInfo.price
//     //     tableRef.value.searchInfo.inventory = searchRef.value.searchInfo.inventory
//     //     tableRef.value.searchInfo.hand = searchRef.value.searchInfo.hand
//     //     tableRef.value.searchInfo.skin = searchRef.value.searchInfo.skin
//     //     tableRef.value.searchInfo.heat = searchRef.value.searchInfo.heat

//     // }
// }
// const addClick = () => {
//     router.push({
//         name: 'products_detail',
//         query: {
//             tid: route.params.id,
//             type: 'add',
//             h_id: route.query.h_id,
//             p_id: route.query.p_id,
//             p_l_no: route.query.p_l_no,
//             p_l_name: route.query.p_l_name,
//             p_o_o: route.query.p_o_o,
//             style: route.query.style,
//             pattern: route.query.pattern,
//             status: route.query.status
//         }
//     })
// }

const search = (val) => {
    // 需要判断一下逻辑 不可能同时又2个为true
    // let arr = [searchRef.value.checkedHands, searchRef.value.checkedHeat, searchRef.value.checkedSkin, searchRef.value.checkedArt]
    // if (arr.filter(item => item).length > 1) {
    //     setTimeout(() => {
    //         tableRef.value.searchInfo.keyword = val.keyword
    //         tableRef.value.searchInfo.hscode = val.hscode
    //         tableRef.value.searchInfo.hscode_id = val.hscode_id
    //         tableRef.value.searchInfo.publicType = val.publicType
    //         tableRef.value.searchInfo.status = val.status
    //         tableRef.value.searchInfo.price = val.price
    //         tableRef.value.searchInfo.inventory = val.inventory
    //         tableRef.value.searchInfo.hand = searchRef.value.checkedHands ? val.hand : [] // 增加条件 需要勾选了才去查询
    //         tableRef.value.searchInfo.skin = searchRef.value.checkedSkin ? val.skin : [] // 增加条件 需要勾选了才去查询
    //         tableRef.value.searchInfo.heat = searchRef.value.checkedHeat ? val.heat : [] // 增加条件 需要勾选了才去查询
    //         tableRef.value.searchInfo.aesthetic_comfort = searchRef.value.checkedArt ? val.art : [] // 增加条件 需要勾选了才去查询
    //         tableRef.value.searchInfo.hand_feeling_layer = val.layer
    //     }, 1000)
    //     return
    // }
    tableRef.value.searchInfo.keyword = val.keyword
    tableRef.value.searchInfo.hscode = val.hscode
    tableRef.value.searchInfo.hscode_id = val.hscode_id
    tableRef.value.searchInfo.publicType = val.publicType == 4 ? '' : val.publicType
    tableRef.value.searchInfo.status = val.status
    tableRef.value.searchInfo.price = [...val.price] // 钱拷贝
    tableRef.value.searchInfo.inventory = [...val.inventory] // 钱拷贝
    tableRef.value.searchInfo.hand = searchRef.value.checkedHands ? [...val.hand] : [] // 增加条件 需要勾选了才去查询
    tableRef.value.searchInfo.skin = searchRef.value.checkedSkin ? [...val.skin] : [] // 增加条件 需要勾选了才去查询
    tableRef.value.searchInfo.heat = searchRef.value.checkedHeat ? [...val.heat] : [] // 增加条件 需要勾选了才去查询
    tableRef.value.searchInfo.aesthetic_comfort = searchRef.value.checkedArt ? [...val.art] : [] // 增加条件 需要勾选了才去查询
    tableRef.value.searchInfo.production_line_name = val.production_line_name
    tableRef.value.searchInfo.productType = val.productType
    tableRef.value.searchInfo.hand_feeling_layer = val.layer
    tableRef.value.searchInfo.template_status = val.template_status


}

const toogleSearch = () => {
    showSearch.value = !showSearch.value
}

// const getProductTemplatePtFun = async () => {
//     // 获取公开类型
//     const resp = await getProductTemplatePt()
//     if (resp) {
//         publicTypeList.value = resp.payload;
//         // console.log('数据库公开类型++', publicTypeList.value);
//     }
// }

const updateTabData = (data) => {
    // all_total: 0
    // data: []
    // private_total: 0
    // public_total: 0
    // supply_chain_public_total: 0
    tabList.value[0].number = data.all_total
    tabList.value[1].number = data.private_total
    tabList.value[2].number = data.supply_chain_public_total
    tabList.value[3].number = data.public_total
}


const synchronizeData = async () => {
    // 查询配置了商城ip 信息没有
    const resp = await getB2cByUser();
    if(resp.code ==1) {
        showMessage('danger', getLangValue('product-management.no_b2c_info'))
        return
    }
    console.log(resp.payload);
    const {ip, auth_key, company_info} = resp.payload;
    // 同步数据
    console.log(tableRef.value.tableInfo);
    let data = tableRef.value.tableInfo.filter(item => item.checked1)
    if (data.length == 0) {
        showMessage('info', getLangValue('product-management.no_synchronize_data'))
        return
    }
    // 判断是否完全公开 并且通过认证
    let data1 = data.filter(item => item.public_type !== 2 || item.status !== 2)
    if (data1.length) {
        showMessage('info', getLangValue('product-management.synchronize_data_error'))
        return
    }
    // // 产品分类
    // const catergory = getCatergoryName()
    const host = window.location.host; // 获取当前域名
    // 同步数据
    tableRef.value.loading = true;
    for (const item of data) {
        // 同步数据

        await startSynchronizeData(item, ip, auth_key, company_info, host)
        // 等待1s
        await sleep(1000)
    }
    tableRef.value.loading = false;
    showMessage('success', getLangValue('product-management.synchronize_data_sucess'))
}

const sleep = (ms) => {
    // 等待
    return new Promise(resolve => setTimeout(resolve, ms));
}

const startSynchronizeData = async (orgin_data,ip, auth_key, company_info, host) => {
    /**
     * 开始迁移产品数据
     */
    // 获取图片数据
    let data = {
        name: orgin_data.name,
        price: orgin_data.price,
        inventory: orgin_data.inventory,
        size: orgin_data.size,
        color: orgin_data.color,
        imageList: [...new Set(orgin_data.picture)],
        qrcodeImgUrl: orgin_data.qrcodeImgUrl,
        gtin: `FBD${orgin_data.pid}`,
        company_id : company_info.id,
        id: orgin_data.id,
        host: host, // 新增一个域名信息
    }
    // 需要补充部分数据 通过详情获取
    const resp = await getProductDetail(orgin_data.id)
    const { product_info } = resp.payload //产品信息
    const base_info = product_info.children.find(item => item.key == 'product_info_base_info') //产品信息里面的基本信息
    // 获取部分信息 
    // 类型 批次号，产品描述，批次量，产地，产品洗涤使用说明，产品回收/丢弃说明
    const keyList = {
        "type": { key: "product_info_base_info_type", parent: 'base_info', },
        "batchNumber": { key: "product_info_base_info_batch_size", parent: 'base_info', },
        "productDescription": { key: "product_info_base_info_description", parent: 'base_info', },
        "batchValue": { key: "product_info_base_info_batch_number", parent: 'base_info', },
        "washing": { key: "product_washing_instructions", parent: 'product_info', },
        "recycling": { key: "product_recycling_discarding_instructions", parent: 'product_info', },
        "product_trademark": { key: "product_trademark", parent: 'product_info', },
    }
    //组装数据
    for (const key in keyList) {
        const { key: n_key, parent } = keyList[key]
        let obj = parent == 'base_info' ? base_info?.children?.find(item => item.key == n_key) : product_info?.children?.find(item => item.key == n_key)
        data[key] = {
            name: obj?.name, //中文
            name_en: obj?.name_en, //英文
            value: n_key== 'product_trademark'?  obj?.value: obj?.value || '', //值
        }
    }
    // 产地特殊处理
    data.orgrin = {
        name: getLangValueByKey("product-template.origin",), // 中文
        name_en: getLangValueByKey("product-template.origin", "en"), // 英文
        value: `${resp.payload.production_line?.place_of_origin?.name}-${resp.payload.production_line?.place_of_origin?.province}` //产地 产品线里面获取
    }
    // 注册id date
    data.registerId = {
        name: getLangValueByKey("product-template.eu_pigital_product _passport_registry_id",), // 中文
        name_en: getLangValueByKey("product-template.eu_pigital_product _passport_registry_id", "en"), // 英文
        value: product_info.eu_registry_id || '-', //值
    }
    data.registerDate = {
        name: getLangValueByKey("product-template.eu_pigital_product _passport_registry_date",), // 中文
        name_en: getLangValueByKey("product-template.eu_pigital_product _passport_registry_date", "en"), // 英文
        value: product_info.eu_registry_date || '-', //值
    }

    console.log(data);
    // 产品分类用产品线名称
    let catergory = orgin_data?.production_line?.production_line_name
    let catergory_en = orgin_data?.production_line?.production_line_name_en
    // 开始同步数据
    let params = {
        catergory, //分类
        catergory_en, //分类英文
        data, // 产品数据
        ip, 
        auth_key
    }
    // 吊后台接口 去迁移产品
    try {
        await product_data_transport(params)
    } catch (e) {
        showMessage('danger', `${data.name}:${getLangValue('product-management.synchronize_data_fail')}`)

    }

}

onMounted(() => {
})



</script>
<template>
    <Layout>
        <PageHeader :title="PageHeaderT" :items="PageHeaderItems" />
        <!-- <div style="overflow-x: auto; overflow-y: hidden; height: calc(100vh - 140px);"> -->
        <!-- min-height: calc(100vh - 140px) -->
        <div style="height: calc(100vh - 160px)" class="w-100">
            <div class="d-flex w-100 my-scroll-bar" style="height: 100%; position: relative; overflow-x: none;">
                <div class="search bg-white card mb-0" style="margin-right: 1.5rem;min-width: 360px; max-width: 360px;"
                    v-show="showSearch" :title="getLangValue('product-management', 'advanced_search')">
                    <div class="w-100"
                        style="background-color: #E2E8ED; height: 40px; line-height: 40px; padding-left: 20px;font-size: 16px;">
                        {{ getLangValue('product-management', "advanced_search") }}</div>
                    <div style="height:calc(100% - 40px);">
                        <searchCom @search="search" ref="searchRef" :showSearch="showSearch" />
                    </div>
                </div>
                <!-- <div class="card" style="flex: 8;"> -->
                <!-- height: calc(100vh - 140px); min-width: calc(100% - 380px); -->
                <div class="" style="flex: 1; height: 100%; ">
                    <div class="py-4 d-flex justify-content-between bg-white card-header border-0">
                        <div class="d-flex align-items-center">
                            <img :src="collapseImg" style="width: 30px;" class="mx-2 cursor-pointer" v-show="showSearch"
                                @click="toogleSearch">
                            <img :src="collapseImg" style="width: 30px; transform: rotateY(180deg);"
                                class="mx-2 cursor-pointer" v-show="!showSearch" @click="toogleSearch">

                            <span style="font-size: 16px;">{{ getLangValue('product-management', 'title1') }}</span>
                        </div>
                        <button v-permit="'product-management.transport'" type="button" class="btn btn-success me-3"
                            v-if="!route.query.p_id && !route.query.h_id && !route.query.status"
                            @click="synchronizeData" style="min-width: 140px;">
                            {{ getLangValue("product-management", "synchronize_data") }}
                        </button>
                    </div>
                    <!-- table部分 -->
                    <div style=" height: calc(100% - 75.5px); " class="bg-white card">
                        <Table ref="tableRef" @updateTabData="updateTabData" :showSearch="showSearch"
                            style="height: 100%;" />
                    </div>
                </div>

            </div>
        </div>
    </Layout>
</template>
<style scoped>
.nav-success.nav-tabs-custom .nav-link.active::after {
    background-color: #405189;
}

:deep(.el-select__placeholder.is-transparent) {
    font-size: 0.71094rem;
    color: #878a99 !important;
}

:deep(.el-select__selected-item.el-select__placeholder) {
    font-size: 0.71094rem;
    color: #212529;
}

:deep(.el-cascader .el-input__inner) {
    font-size: 0.71094rem;
    color: #212529;
}

:deep(.el-cascader .el-input__inner::placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-webkit-input-placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-moz-placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-moz-placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-ms-input-placeholder) {
    color: #878a99;
}
</style>
